import { useEffect, useState } from 'react';
import { Editor, Kites } from '../services/Store';
import { Store } from '../types';

export function useEditor() {
    const [editor, setEditor] = useState<Store['editor']>(Editor.get());

    useEffect(() => {
        const subscription = Editor.stateChanged.subscribe(
            ({ editor: nextEditor }) => {
                setEditor({ ...nextEditor });
            }
        );
        return () => subscription.unsubscribe();
    }, [setEditor, Editor]);

    return {
        editor,
        save: (id) => Kites.saveKite(id),
        copy: () => Kites.copyKite(),
        toggleShadow: () => Editor.toggleShadow(),
        selectMaterial: (material) => Editor.selectMaterial(material),
    };
}
